import { useEffect, useState } from "react";
import ReactHlsPlayer from "react-hls-player";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { BsCardImage } from "react-icons/bs";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import intApi from "../../api/int_api";
import orgApi from "../../api/org_api";
import { GS, Timer } from "../../Services";
import FeedbackSubmitted from "./components/FeedbackSubmitted";
import InfoBlock from "./components/InfoBlock";
export interface FeedbackDetailsProps {
  feedback_status: string;
  status: string;
  utc_starttime: Date;
  utc_endtime: Date;
  video_url: string;
  candidate: {
    id: string;
    first_name: string;
    last_name: string;
    email: string;
    designation: string;
    organization: string;
    mobile: string;
    mcc: string;
  };
  interviewer: {
    candidate: { first_name: string; last_name: string };
  };
  feedback: {
    f_primary: {
      skill_id: number;
      rating: number;
      program_concept: string;
      logics: string;
      dev_tools: string;
      skill: {
        name: string;
      };
    }[];
    f_secondary: {
      skill_id: number;
      rating: number;
      program_concept: string;
      logics: string;
      dev_tools: string;
      skill: {
        name: string;
      };
    }[];
  }[];
}
export interface IPostProps {
  job_title: string;
  template: {
    t_p_skill: { weightage: number; skill: { name: string } }[];
    t_s_skill: { weightage: number; skill: { name: string } }[];
  };
}

interface InterviewFormValuesProps {
  id: string | null;
  interview_status: string;
  url: string;
  communication_skill: number;
  attention: number;
  intrigity: number;
  co_operation: number;
  stress_tolerance: number;
  learning_ability: number;
  window_violation: boolean;
  window_violation_cmt: string;
  incomplete_reason_id: string | null;
  incomplete_reason_cmt: string;
  comments: string;
  sit_score: number;
  proxy: boolean;
  candidate_no_show: boolean;
  recommended_status: string;
}

const INITIAL_FEEDBACK_VALUES: InterviewFormValuesProps = {
  id: null,
  interview_status: "Completed",
  url: "",
  communication_skill: 0,
  attention: 0,
  intrigity: 0,
  co_operation: 0,
  stress_tolerance: 0,
  learning_ability: 0,
  window_violation: false,
  window_violation_cmt: "",
  incomplete_reason_id: null,
  incomplete_reason_cmt: "",
  comments: "",
  sit_score: 0,
  proxy: false,
  candidate_no_show: false,
  recommended_status: "",
};

interface ErrorProps {
  interview_status?: string;
  communication_skill?: string;
  attention?: string;
  intrigity?: string;
  co_operation?: string;
  stress_tolerance?: string;
  learning_ability?: string;
  window_violation_cmt?: string;
  incomplete_reason_cmt?: string;
  comments?: string;
  sit_score?: string;
  url?: string;
}

const INCOMPLETE_REASONS = [
  {
    label: "Candidate No Show",
    value: "242d3bf6-b87d-48b8-aaa5-345089caa0e6",
  },
  {
    label: "Candidate is Not Available",
    value: "c3b0d137-2cee-43aa-b33d-1b56800b943d",
  },
  {
    label: "Candidate is a Proxy",
    value: "deb1fa06-cea2-44ed-87c2-e3957db71c7d",
  },
  {
    label: "Interview Postponed / Position on Hold",
    value: "995cdbc2-8cbb-4924-8d5e-22359cf11ceb",
  },
  { label: "Position Closed", value: "7ae6e59e-91f8-41e7-9d44-7cd4075bec63" },
  {
    label: "Scheduling Conflict with Other Meetings",
    value: "7de776c1-078f-4214-9e11-e7227bc2889b",
  },
  {
    label: "Unscheduled Call",
    value: "76d9e46b-fe9b-4a6f-a565-c58ba02466cc",
  },
  {
    label: "Poor Network Connectivity",
    value: "d144e81d-315d-465c-88d2-f3d1d2e4099b",
  },
  {
    label: "Personal Emergency",
    value: "40a7cc91-db38-4d64-bdab-0d3df6e24ecb",
  },
  { label: "Personal Reasons", value: "fb6e319b-e705-4bec-a20a-d842724498b9" },
  { label: "Not to Disclose", value: "d98cb4ec-4eed-42de-a880-4fa2ac5b2674" },
  { label: "Other", value: "a44f6086-d9f6-46aa-a4a4-97c9050ed6ad" },
];
interface SkillProps {
  skill_name: string;
  skill_id: string;
  skill_rating: number;
  experience: string;
  program_concept: string;
  logics: string;
  development_tools: string;
  weightage: number;
}

const INITIAL_SKILLS = {
  skill_rating: 0,
  experience: "",
  program_concept: "",
  logics: "",
  development_tools: "",
  skill_type: "technical",
};

interface SkillErrorProps {
  skill_rating?: string;
  program_concept?: string;
  logics?: string;
  development_tools?: string;
}

const INITIAL_SKILLS_ERR: SkillErrorProps = {
  skill_rating: "",
  program_concept: "",
  logics: "",
  development_tools: "",
};

const AddFeedbackTech = ({ isEdit }: { isEdit: boolean }) => {
  const { schedule_id } = useParams();
  const [schedule, setSchedule] = useState<FeedbackDetailsProps>();
  const [post, setPost] = useState<IPostProps>();
  const [feedbackFormValues, setFeedbackFormValues] =
    useState<InterviewFormValuesProps>(INITIAL_FEEDBACK_VALUES);
  const [errors, setErrors] = useState<ErrorProps>({});
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [primarySkills, setPrimarySkills] = useState<SkillProps[]>([]);
  const [secondarySkills, setSecondarySkills] = useState<SkillProps[]>([]);
  const [p_skillsErr, setP_SkillsErr] = useState<SkillErrorProps[]>([]);
  const [s_skillsErr, setS_SkillsErr] = useState<SkillErrorProps[]>([]);

  useEffect(() => {
    if (schedule_id) {
      fetchScheduleInfo();
    }
  }, [schedule_id]);

  const fetchScheduleInfo = async () => {
    setIsLoading(true);
    try {
      const res = await orgApi.getScheduleData(schedule_id);
      if (res.data.success) {
        setSchedule(res.data.schedule);

        const data = res.data.schedule.feedback;

        if (isEdit && data && data.length > 0) {
          const feedback = data[0];
          setFeedbackFormValues({
            id: feedback.id,
            interview_status: feedback.proxy
              ? "Proxy"
              : feedback.candidate_no_show
              ? "No Show"
              : feedback.interview_status,
            incomplete_reason_cmt: feedback.incomplete_reason_cmt || "",
            incomplete_reason_id: feedback.incomplete_reason_id || null,
            comments: feedback.comments || "",
            communication_skill: feedback.communication_skill || 0,
            attention: feedback.attention || 0,
            intrigity: feedback.intrigity || 0,
            co_operation: feedback.co_operation || 0,
            stress_tolerance: feedback.stress_tolerance || 0,
            learning_ability: feedback.learning_ability || 0,
            window_violation: feedback.window_violation || false,
            window_violation_cmt: feedback.window_violation_cmt || "",
            sit_score: feedback.sit_score || 0,
            recommended_status: feedback.recommended_status || "",
            url: feedback.url || null,
            proxy: feedback.proxy || false,
            candidate_no_show: feedback.candidate_no_show || false,
          });

          fetchPostInfo(res.data.schedule.post_id, feedback);
        } else {
          fetchPostInfo(res.data.schedule.post_id, null);
          setFeedbackFormValues({
            ...feedbackFormValues,
            url: res.data.schedule["url"] || null,
          });
        }
      } else {
        toast.error(res.data.msg);
      }
    } catch (error) {
      toast.error("Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };

  const fetchPostInfo = async (postId: string, feedback: any) => {
    const res = await intApi.getSingleJdDetail(postId);
    if (res.data.success) {
      const jdDetail = res.data.post;
      setPost(jdDetail);
      if (isEdit) {
        interface SkillMeta {
          id: string;
          name: string;
        }
        interface FeedbackSkill {
          skill_rating: number;
          experience: string;
          program_concept: string | null;
          logics: string | null;
          development_tools: string | null;
          skill: SkillMeta;
        }

        const p_skills =
          feedback?.fp_skill && feedback?.fp_skill?.length > 0
            ? feedback?.fp_skill?.map((skill: FeedbackSkill) => ({
                skill_name: skill.skill.name,
                skill_id: skill.skill.id,
                weightage: 0,
                skill_rating: skill.skill_rating || 0,
                experience: skill.experience || "",
                program_concept: skill.program_concept || "",
                logics: skill.logics || "",
                development_tools: skill.development_tools || "",
                skill_type: "technical",
              }))
            : jdDetail?.template?.t_p_skill?.map(
                (p_el: {
                  skill: { name: string; id: string };
                  weightage: number;
                }) => ({
                  skill_name: p_el.skill.name,
                  skill_id: p_el.skill.id,
                  weightage: p_el.weightage,
                  ...INITIAL_SKILLS,
                })
              );

        const s_skills =
          feedback?.fs_skill && feedback?.fs_skill?.length > 0
            ? feedback?.fs_skill?.map((skill: FeedbackSkill) => ({
                skill_name: skill.skill.name,
                skill_id: skill.skill.id,
                weightage: 0,
                skill_rating: skill.skill_rating || 0,
                experience: skill.experience || "",
                program_concept: skill.program_concept || "",
                logics: skill.logics || "",
                development_tools: skill.development_tools || "",
                skill_type: "technical",
              }))
            : jdDetail?.template?.t_s_skill?.map(
                (p_el: {
                  skill: { name: string; id: string };
                  weightage: number;
                }) => ({
                  skill_name: p_el.skill.name,
                  skill_id: p_el.skill.id,
                  weightage: p_el.weightage,
                  ...INITIAL_SKILLS,
                })
              );

        setPrimarySkills(p_skills);
        setSecondarySkills(s_skills);
        setP_SkillsErr(p_skills.map(() => INITIAL_SKILLS_ERR));
        setS_SkillsErr(s_skills.map(() => INITIAL_SKILLS_ERR));
      } else {
        const p_skills = jdDetail.template.t_p_skill;
        const s_skills = jdDetail.template.t_s_skill;
        setPrimarySkills(
          p_skills.map(
            (p_el: {
              skill: { name: string; id: string };
              weightage: number;
            }) => ({
              skill_name: p_el.skill.name,
              skill_id: p_el.skill.id,
              weightage: p_el.weightage,
              ...INITIAL_SKILLS,
            })
          )
        );
        setSecondarySkills(
          s_skills.map(
            (s_el: {
              skill: { name: string; id: string };
              weightage: number;
            }) => ({
              skill_name: s_el.skill.name,
              skill_id: s_el.skill.id,
              weightage: s_el.weightage,
              ...INITIAL_SKILLS,
            })
          )
        );
        setP_SkillsErr(p_skills.map(() => INITIAL_SKILLS_ERR));
        setS_SkillsErr(s_skills.map(() => INITIAL_SKILLS_ERR));
      }
    } else {
      toast.error(res.data.msg);
    }
  };

  const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setErrors((prev) => ({ ...prev, image: "" }));
    const file = event.target.files?.[0];
    if (!file) return;

    if (!file.type.startsWith("image/")) {
      setErrors((prev) => ({
        ...prev,
        image: "Please select a valid image file",
      }));
    } else if (file.size > 2 * 1024 * 1024) {
      setErrors((prev) => ({
        ...prev,
        image: "File size exceeds 2MB. Please upload a smaller file.",
      }));
    } else {
      const reader = new FileReader();
      reader.onload = (e: ProgressEvent<FileReader>) => {
        const result = e.target?.result;
        if (typeof result !== "string") {
          setErrors((prev) => ({ ...prev, image: "Could not read the file." }));
        } else {
          setFeedbackFormValues({ ...feedbackFormValues, url: result });
          setErrors((prev) => ({ ...prev, image: "" }));
        }
      };
      reader.readAsDataURL(file);
    }
  };

  const validateFeedbackForm = () => {
    const newError: ErrorProps = {};
    const fb = feedbackFormValues;
    if (!fb.interview_status) {
      newError.interview_status = "Interview status is required";
    }
    if (!fb.url) {
      newError.url = "Profile picture is required";
    }
    if (fb.interview_status === "Incomplete") {
      if (!fb.incomplete_reason_cmt) {
        newError.incomplete_reason_cmt = "Reason is required";
      }
      if (!fb.comments) {
        newError.comments = "Incomplete comments is required";
      }
    }
    if (fb.interview_status === "Completed") {
      if (!fb.sit_score) {
        newError.sit_score = "Screenit score is required";
      }
      if (!fb.comments) {
        newError.comments = "Incomplete comments is required";
      }
      if (fb.window_violation && !fb.window_violation_cmt) {
        newError.window_violation_cmt = "Violation comments is required";
      }

      if (fb.communication_skill === 0) {
        newError.communication_skill = "Communication skill is required";
      }
      if (fb.attention === 0) {
        newError.attention = "Attention is required";
      }

      if (fb.intrigity === 0) {
        newError.intrigity = "Integrity is required";
      }
      if (fb.co_operation === 0) {
        newError.co_operation = "Cooperation is required";
      }
      if (fb.stress_tolerance === 0) {
        newError.stress_tolerance = "Stress tolerance is required";
      }
      if (!fb.learning_ability) {
        newError.learning_ability = "Learning ability is required";
      }
    }
    setErrors(newError);
    return Object.keys(newError).length > 0;
  };

  const validatePrimarySkills = () => {
    const newErrors: SkillErrorProps[] = [];

    primarySkills.forEach((skill) => {
      const error: SkillErrorProps = {};

      if (!skill.skill_rating) {
        error.skill_rating = "Skill rating is required";
      }
      if (!skill.program_concept) {
        error.program_concept = "Program concept is required";
      }
      if (!skill.logics) {
        error.logics = "Logics is required";
      }
      if (!skill.development_tools) {
        error.development_tools = "Development tools is required";
      }

      newErrors.push(error);
    });

    setP_SkillsErr(newErrors);

    return newErrors.some((err) =>
      Object.values(err).some((msg) => msg !== undefined && msg !== "")
    );
  };

  const validateSecondarySkills = () => {
    const newErrors: SkillErrorProps[] = [];

    secondarySkills.forEach((skill) => {
      const error: SkillErrorProps = {};

      if (!skill.skill_rating) {
        error.skill_rating = "Skill rating is required";
      }
      if (!skill.program_concept) {
        error.program_concept = "Program concept is required";
      }
      if (!skill.logics) {
        error.logics = "Logics is required";
      }
      if (!skill.development_tools) {
        error.development_tools = "Development tools is required";
      }

      newErrors.push(error);
    });

    setS_SkillsErr(newErrors);

    return newErrors.some((err) =>
      Object.values(err).some((msg) => msg !== undefined && msg !== "")
    );
  };

  const handleSubmit = async () => {
    if (feedbackFormValues.interview_status === "Completed") {
      if (validatePrimarySkills() || validateSecondarySkills()) {
        toast.warn("Please fill all the required fields");
        return;
      }
    }
    if (validateFeedbackForm()) {
      toast.warn("Please fill all the required fields");
      return;
    }
    setIsLoading(true);

    let req;
    const values = feedbackFormValues;
    if (feedbackFormValues.interview_status === "Completed") {
      req = {
        schedule_id,
        interview_status: values.interview_status,
        comments: values.comments,
        window_violation: values.window_violation,
        window_violoation_cmt: values.window_violation_cmt,
        sit_score: values.sit_score,
        recommended_status: values.recommended_status,
        attention: values.attention,
        communication_skill: values.communication_skill,
        co_operation: values.co_operation,
        intrigity: values.intrigity,
        learning_ability: values.learning_ability,
        stress_tolerance: values.stress_tolerance,
        primary_skill: primarySkills,
        secondary_skill: secondarySkills,
        mandatory_skill: [],
        url: values.url,
      };
    } else {
      req = {
        schedule_id,
        interview_status: "Incomplete",
        candidate_no_show: values.interview_status === "No Show",
        proxy: values.interview_status === "Proxy",
        url: values.url,
        primary_skill: [],
        secondary_skill: [],
        mandatory_skill: [],
        ...(values.interview_status === "Incomplete"
          ? {
              incomplete_reason_id: values.incomplete_reason_id,
              incomplete_reason_cmt: values.incomplete_reason_cmt,
              comments: values.comments,
            }
          : {}),
      };
    }
    if (isEdit && feedbackFormValues.id) {
      handleEditSubmit(feedbackFormValues.id, req);
    } else {
      handleAddSubmit(schedule_id!, req);
    }
  };

  const handleAddSubmit = async (scheduleId: string, req: any) => {
    try {
      const res = await intApi.addFeedback(req, scheduleId);
      if (res.data.success) {
        toast("Feedback Submitted Successfully");
        window.location.replace("https://screenit.io");
      } else {
        toast(res.data.msg);
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };

  const handleEditSubmit = async (feedbackId: string, req: any) => {
    try {
      const res = await intApi.editFeedback(req, feedbackId);
      if (res.data.success) {
        toast("Feedback Submitted Successfully");
        window.location.replace("https://screenit.io");
      } else {
        toast(res.data.msg);
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };

  const handleFieldChange = (field: string, value: string) => {
    setFeedbackFormValues({ ...feedbackFormValues, [field]: value });
    setErrors({ ...errors, [field]: "" });
  };

  const nonTechCriteria: NonTechnicalCriteria[] = [
    {
      key: "communication_skill",
      label: "Communication",
      value: feedbackFormValues.communication_skill,
      error: errors.communication_skill,
    },
    {
      key: "attention",
      label: "Attention to Detail",
      value: feedbackFormValues.attention,
      error: errors.attention,
    },
    {
      key: "intrigity",
      label: "Integrity",
      value: feedbackFormValues.intrigity,
      error: errors.intrigity,
    },
    {
      key: "co_operation",
      label: "Cooperation",
      value: feedbackFormValues.co_operation,
      error: errors.co_operation,
    },
    {
      key: "stress_tolerance",
      label: "Handling Stress",
      value: feedbackFormValues.stress_tolerance,
      error: errors.stress_tolerance,
    },
    {
      key: "learning_ability",
      label: "Learning Ability",
      value: feedbackFormValues.learning_ability,
      error: errors.learning_ability,
    },
  ];

  const getImageLabel = (status: string) => {
    switch (status) {
      case "Completed":
        return "Candidate Profile Picture";
      case "Incomplete":
        return "Interview Incomplete";
      case "No Show":
        return "Candidate Did Not Attend";
      case "Proxy":
        return "Possible Proxy Candidate";
      default:
        return "Upload Candidate Image";
    }
  };

  return (
    <>
    
      <div className="flex justify-center items-center bg-gray-50 min-h-screen p-4">
        {schedule &&
          post &&
          schedule.feedback_status === "Completed" &&
          !isEdit && <FeedbackSubmitted />}

        {((schedule && post && schedule.feedback_status !== "Completed") ||
          isEdit) && (
          <div className="bg-white p-6 rounded-xl border w-full max-w-6xl space-y-4">
            <div className=" flex justify-center">
              <h1 className="text-lg font-bold text-gray-800 mb-1">
                Interview Evaluation Sheet
                <div className="w-16 h-1 bg-blue-500 rounded-full" />
              </h1>
            </div>

            <div className="grid grid-cols-3 bg-primary border-primary p-4 gap-3 rounded-lg">
              <InfoBlock
                label="Candidate Name"
                value={`${schedule?.candidate?.first_name} ${
                  schedule?.candidate?.last_name || ""
                }`}
              />
              <InfoBlock
                label="Interview Date"
                value={
                  schedule?.utc_starttime
                    ? Timer.getDate(schedule?.utc_starttime)
                    : "-"
                }
              />
              <InfoBlock
                label="Interviewer Name"
                value={`${schedule?.interviewer?.candidate?.first_name}
                  ${schedule?.interviewer?.candidate?.last_name || ""}`}
              />
              <InfoBlock
                label="Candidate Email Id"
                value={schedule?.candidate.email!}
              />
              <InfoBlock
                label="Interview Time"
                value={`${
                  schedule?.utc_starttime
                    ? Timer.getTime(schedule?.utc_starttime)
                    : "-"
                } to ${
                  schedule?.utc_endtime
                    ? Timer.getTime(schedule?.utc_endtime)
                    : "-"
                }`}
              />
              <InfoBlock label="Job Title" value={post?.job_title!} />
            </div>

            <form
              onSubmit={(e) => {
                e.preventDefault();
                handleSubmit();
              }}
              className=" space-y-4"
            >
              <div className="max-w-80">
                <Dropdown
                  label="Interview Status"
                  required
                  options={[
                    { value: "Completed", label: "Completed" },
                    { value: "Incomplete", label: "Incomplete" },
                    { value: "No Show", label: "Candidate No Show" },
                    { value: "Proxy", label: "Candidate Proxy" },
                  ]}
                  value={feedbackFormValues.interview_status}
                  onChange={(obj) =>
                    handleFieldChange("interview_status", obj.value)
                  }
                  error={errors.interview_status}
                />
              </div>

              <ProfileImageUpload
                label={getImageLabel(feedbackFormValues.interview_status)}
                selectedImage={feedbackFormValues.url}
                error={errors.url}
                onImageChange={handleImageChange}
                required={feedbackFormValues.interview_status !== "Completed"}
              />

              {feedbackFormValues.interview_status === "Incomplete" && (
                <div className="space-y-4">
                  <div className=" max-w-96">
                    <Dropdown
                      label="Reason"
                      required
                      options={INCOMPLETE_REASONS}
                      value={feedbackFormValues.incomplete_reason_cmt}
                      onChange={(obj) => {
                        setFeedbackFormValues((prev) => ({
                          ...prev,
                          incomplete_reason_cmt: obj.label,
                          incomplete_reason_id: obj.value,
                        }));
                        setErrors((prev) => ({
                          ...prev,
                          incomplete_reason_cmt: "",
                        }));
                      }}
                      error={errors.incomplete_reason_cmt}
                    />
                  </div>

                  <TextArea
                    label="Comments"
                    name="incomplete_comments"
                    value={feedbackFormValues.comments}
                    onChange={(e) =>
                      handleFieldChange("comments", e.target.value)
                    }
                    error={errors.comments}
                    required
                  />
                </div>
              )}

              {feedbackFormValues.interview_status === "Completed" && (
                <div className="space-y-4">
                  <div className="">
                    <h2 className="text-lg font-semibold text-gray-800 mb-2">
                      Technical Evaluation
                    </h2>
                    <p className="text-sm text-gray-600">
                      Please evaluate the candidate on the following on a scale
                      of 1 to 5 (1 Lowest, 5 Highest)
                    </p>
                  </div>

                  <div className=" space-y-4">
                    <h3 className="text-md font-semibold text-gray-800">
                      Required Technical Skills
                    </h3>
                    {primarySkills.map((skill, p_index) => (
                      <TechnicalSkillCard
                        key={skill.skill_id}
                        skill={skill}
                        setSkill={(updatedSkill) => {
                          const updatedSkills = [...primarySkills];
                          updatedSkills[p_index] = updatedSkill;
                          setPrimarySkills(updatedSkills);
                        }}
                        error={p_skillsErr[p_index]}
                        setErrors={(p_err) => {
                          const updatedErr = [...p_skillsErr];
                          updatedErr[p_index] = p_err;
                          setP_SkillsErr(updatedErr);
                        }}
                      />
                    ))}
                  </div>

                  <div className=" space-y-4">
                    <h3 className="text-md font-semibold text-gray-800">
                      Preferred Technical Skills
                    </h3>
                    {secondarySkills.map((skill, s_index) => (
                      <TechnicalSkillCard
                        key={skill.skill_id}
                        skill={skill}
                        setSkill={(updatedSkill) => {
                          const updatedSkills = [...secondarySkills];
                          updatedSkills[s_index] = updatedSkill;
                          setSecondarySkills(updatedSkills);
                        }}
                        error={s_skillsErr[s_index]}
                        setErrors={(s_err) => {
                          const updatedErr = [...s_skillsErr];
                          updatedErr[s_index] = s_err;
                          setS_SkillsErr(updatedErr);
                        }}
                      />
                    ))}
                  </div>

                  <NonTechnicalEvaluation
                    criteria={nonTechCriteria}
                    onRatingChange={(key, rating) => {
                      setFeedbackFormValues((prev) => ({
                        ...prev,
                        [key]: rating,
                      }));
                      setErrors((prev) => ({ ...prev, [key]: "" }));
                    }}
                  />

                  <OtherInformationSection
                    feedbackFormValues={feedbackFormValues}
                    setFeedbackFormValues={setFeedbackFormValues}
                    errors={errors}
                    setErrors={setErrors}
                  />
                </div>
              )}

              <div className="flex justify-end gap-4 pt-4 border-t border-gray-200">
                <button
                  type="submit"
                  disabled={isLoading}
                  className="flex items-center justify-center rounded-lg text-sm font-medium text-white bg-primary hover:bg-indigo-700 transition border border-primary disabled:opacity-50 disabled:cursor-not-allowed min-w-40 min-h-10"
                >
                  {isLoading ? (
                    <AiOutlineLoading3Quarters className="animate-spin duration-100 ease-in-out" />
                  ) : (
                    "Submit Feedback"
                  )}
                </button>
              </div>
            </form>
            {schedule?.status === "Completed" && (
              <div className="flex justify-start mt-2">
                <div className="my-2 flex flex-col gap-2">
                  {GS.getFileExtension(schedule.video_url) !== "mp4" ? (
                    <ReactHlsPlayer
                      src={schedule.video_url}
                      autoPlay={false}
                      controls={true}
                      width="750"
                      height="500"
                    />
                  ) : (
                    <video
                      src={schedule.video_url}
                      autoPlay={false}
                      controls={true}
                      width="750"
                      height="500"
                    />
                  )}
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default AddFeedbackTech;

interface DropdownProps {
  value: string;
  onChange: (value: { value: string; label: string }) => void;
  error?: string;
  disabled?: boolean;
  className?: string;
  options?: { value: string; label: string }[];
  label?: string;
  required?: boolean;
}

export const Dropdown = ({
  value,
  onChange,
  error,
  disabled = false,
  className = "",
  options = [],
  label,
  required = false,
}: DropdownProps) => {
  const inputClass = `w-full px-3 py-2 border rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
    error ? "border-red-500 bg-red-50" : "border-gray-300 focus:border-blue-500"
  }`;

  return (
    <div className={`space-y-2 text-xs 2xl:text-sm  ${className}`}>
      <label className=" font-medium text-gray-700">
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      <select
        value={value}
        onChange={(e) => {
          const selectedOption = options.find(
            (option) => option.value === e.target.value
          ) || { value: "", label: "" };
          onChange(selectedOption);
        }}
        disabled={disabled}
        className={inputClass}
      >
        <option value="" disabled>
          Select Status
        </option>
        {options.map((option) => (
          <option key={option.value} value={option.value} label={option.label}>
            {option.label}
          </option>
        ))}
      </select>
      {error && <p className="text-sm text-red-600">{error}</p>}
    </div>
  );
};

interface ProfileImageUploadProps {
  selectedImage: string | null;
  error?: string;
  onImageChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  label?: string;
  required?: boolean;
  className?: string;
}

export const ProfileImageUpload = ({
  selectedImage,
  error,
  onImageChange,
  label,
  required,
  className = "",
}: ProfileImageUploadProps) => {
  return (
    <div className={`space-y-3 ${className}`}>
      <label className="block text-sm font-medium text-gray-700">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>

      <label className="cursor-pointer block">
        <div className="flex items-center w-full max-w-md border-2 border-dashed border-gray-300 rounded-xl hover:border-blue-400 transition-colors duration-200 p-4">
          {selectedImage ? (
            <div className="flex-shrink-0 w-16 h-16 mr-4 overflow-hidden rounded-lg">
              <img
                className="w-full h-full object-cover"
                src={selectedImage}
                alt="Profile preview"
              />
            </div>
          ) : (
            <div className="flex-shrink-0 w-16 h-16 mr-4 flex items-center justify-center bg-gray-50 rounded-lg border border-gray-200">
              <BsCardImage className="text-gray-400" size={24} />
            </div>
          )}

          <div className="flex-1 space-y-1">
            <div className="text-sm font-medium text-gray-700">
              {selectedImage ? "Change Image" : "Upload Image"}
            </div>
            <div className="text-xs text-gray-500">
              Supports JPEG, PNG & JPG formats (Max 2MB)
            </div>
          </div>
        </div>

        <input
          type="file"
          className="hidden"
          accept="image/jpeg,image/png,image/jpg"
          onChange={onImageChange}
        />
      </label>

      {error && (
        <div className="flex items-center space-x-2">
          <div className="w-2 h-2 bg-red-500 rounded-full"></div>
          <p className="text-sm text-red-600">{error}</p>
        </div>
      )}
    </div>
  );
};

interface TextAreaProps {
  label?: string;
  name: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLTextAreaElement>) => void;
  error?: string;
  placeholder?: string;
  rows?: number;
  disabled?: boolean;
  className?: string;
  required?: boolean;
}

export const TextArea = ({
  label,
  name,
  value,
  onChange,
  onBlur,
  error,
  placeholder = "Enter your comments...",
  rows = 3,
  disabled = false,
  className = "",
  required,
}: TextAreaProps) => {
  const inputClass = `w-full px-3 py-2 border rounded-lg  text-xs 2xl:text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none ${
    error ? "border-red-500 bg-red-50" : "border-gray-300 focus:border-blue-500"
  }`;

  return (
    <div className={`space-y-2 ${className}`}>
      {label && (
        <label className="text-sm font-medium text-gray-700">
          {label} {required && <span className="text-red-500">*</span>}
        </label>
      )}
      <div className=" space-y-1">
        <textarea
          name={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={placeholder}
          rows={rows}
          disabled={disabled}
          className={inputClass}
        />
        {error && <p className="text-sm text-red-600">{error}</p>}
      </div>
    </div>
  );
};

interface StarRatingProps {
  rating: number;
  onRatingChange: (rating: number) => void;
  maxStars?: number;
  error?: string;
}

const StarRating = ({
  rating,
  onRatingChange,
  maxStars = 5,
  error,
}: StarRatingProps) => {
  return (
    <div>
      <div className="flex items-center space-x-1">
        {[...Array(maxStars)].map((_, index) => {
          const starValue = index + 1;
          return (
            <svg
              key={starValue}
              onClick={() => onRatingChange(starValue)}
              className={`w-6 h-6 cursor-pointer ${
                starValue <= rating
                  ? "text-yellow-500"
                  : error
                  ? "text-red-100"
                  : "text-gray-300"
              }`}
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.286 3.956a1 1 0 00.95.69h4.162c.969 0 1.371 1.24.588 1.81l-3.37 2.448a1 1 0 00-.364 1.118l1.287 3.957c.3.921-.755 1.688-1.54 1.118l-3.371-2.448a1 1 0 00-1.175 0l-3.371 2.448c-.784.57-1.838-.197-1.539-1.118l1.286-3.957a1 1 0 00-.364-1.118L2.075 9.383c-.783-.57-.38-1.81.588-1.81h4.162a1 1 0 00.95-.69l1.286-3.956z" />
            </svg>
          );
        })}
      </div>
      {error && <p className="text-red-500 text-xs mt-1">{error}</p>}
    </div>
  );
};

interface TechnicalSkillCardProps {
  skill: SkillProps;
  setSkill: (updatedSkill: SkillProps) => void;
  error: SkillErrorProps;
  setErrors: (error: SkillErrorProps) => void;
}

const TechnicalSkillCard = ({
  skill,
  setSkill,
  error,
  setErrors,
}: TechnicalSkillCardProps) => {
  const handleChange = (field: keyof SkillProps, value: string | number) => {
    setSkill({ ...skill, [field]: value });
    setErrors({ ...error, [field]: "" });
  };

  return (
    <div className="border rounded-lg p-4 bg-white space-y-4">
      <div className="flex items-center gap-4 justify-between">
        <div className=" flex items-center gap-4">
          <h2 className="text-lg font-semibold text-gray-800">
            {skill.skill_name}
          </h2>
          {!!skill.weightage && (
            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
              Weightage: {skill.weightage}%
            </span>
          )}
        </div>

        <div className="flex items-center gap-2">
          <label className="text-sm font-medium text-gray-600 mb-1 block">
            Skill Rating <span className="text-red-500">*</span>
          </label>
          <StarRating
            rating={skill.skill_rating}
            onRatingChange={(rating) => {
              setSkill({
                ...skill,
                skill_rating: rating,
                experience:
                  rating === 3 ? "Intermediate" : rating > 3 ? "Good" : "Poor",
              });
              setErrors({ ...error, skill_rating: "" });
            }}
            error={error.skill_rating}
          />
        </div>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        <TextArea
          required
          label="Technical Concepts"
          name="program_concept"
          value={skill.program_concept}
          onChange={(e) => handleChange("program_concept", e.target.value)}
          error={error.program_concept}
        />
        <TextArea
          required
          label="Logics"
          name="logics"
          value={skill.logics}
          onChange={(e) => handleChange("logics", e.target.value)}
          error={error.logics}
        />
        <TextArea
          required
          label="Development Tools"
          name="development_tools"
          value={skill.development_tools}
          onChange={(e) => handleChange("development_tools", e.target.value)}
          error={error.development_tools}
        />
      </div>
    </div>
  );
};

interface NonTechnicalCriteria {
  key: string;
  label: string;
  value: number;
  error?: string;
}

interface NonTechnicalEvaluationProps {
  criteria: NonTechnicalCriteria[];
  onRatingChange: (key: string, rating: number) => void;
  className?: string;
}

const NonTechnicalEvaluation = ({
  criteria,
  onRatingChange,
  className = "",
}: NonTechnicalEvaluationProps) => {
  return (
    <div className={`w-full ${className}`}>
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-gray-800">
          Non-Technical Evaluation
        </h3>
        <span className="text-sm text-gray-500">Rate each from 1 to 5</span>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {criteria.map((criterion) => (
          <div
            key={criterion.key}
            className="bg-white border rounded-lg p-4 transition"
          >
            <div className="flex justify-between items-center">
              <h4 className="text-sm font-medium text-gray-700">
                {criterion.label} <span className="text-red-500">*</span>
              </h4>
              <div className="flex items-center gap-2">
                <StarRating
                  rating={criterion.value}
                  onRatingChange={(rating) =>
                    onRatingChange(criterion.key, rating)
                  }
                  error={criterion.error}
                />
                <span className="text-xs text-gray-500">
                  {criterion.value}/5
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const OtherInformationSection = ({
  feedbackFormValues,
  setFeedbackFormValues,
  errors,
  setErrors,
}: {
  feedbackFormValues: InterviewFormValuesProps;
  setFeedbackFormValues: React.Dispatch<
    React.SetStateAction<InterviewFormValuesProps>
  >;
  errors: ErrorProps;
  setErrors: React.Dispatch<React.SetStateAction<ErrorProps>>;
}) => {
  const handleFieldChange = (
    field: string,
    value: string | number | boolean
  ) => {
    setFeedbackFormValues((prev) => ({ ...prev, [field]: value }));
    setErrors((prev) => ({ ...prev, [field]: "" }));
  };
  return (
    <div className=" space-y-4">
      <h2 className="text-lg font-semibold text-gray-800">Other Information</h2>

      <div className=" grid md:grid-cols-2 gap-4">
        <div className="">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Window Violation
          </label>
          <div className="inline-flex border rounded-md overflow-hidden">
            <button
              type="button"
              className={`px-5 py-2 text-sm font-medium ${
                !feedbackFormValues.window_violation
                  ? "bg-primary text-white"
                  : "bg-white text-gray-700 hover:bg-gray-100"
              }`}
              onClick={() => handleFieldChange("window_violation", false)}
            >
              No
            </button>
            <button
              type="button"
              className={`px-5 py-2 text-sm font-medium ${
                feedbackFormValues.window_violation
                  ? "bg-primary text-white"
                  : "bg-white text-gray-700 hover:bg-gray-100"
              }`}
              onClick={() => handleFieldChange("window_violation", true)}
            >
              Yes
            </button>
          </div>
        </div>
        {feedbackFormValues.window_violation && (
          <TextArea
            required
            label="Violation Comments"
            name="violation_comments"
            value={feedbackFormValues.window_violation_cmt}
            onChange={(e) =>
              handleFieldChange("window_violation_cmt", e.target.value)
            }
            error={errors.window_violation_cmt}
          />
        )}
      </div>

      <h2 className="text-lg font-semibold text-gray-800">
        Final Recommendation
      </h2>

      <div className="">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Screenit Score <span className="text-red-500">*</span>
        </label>
        <div className="flex flex-wrap gap-2">
          {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((score) => (
            <button
              key={score}
              type="button"
              className={`w-10 h-10 rounded-full flex items-center justify-center text-sm font-medium border transition ${
                feedbackFormValues.sit_score >= score
                  ? "bg-blue-500 text-white border-blue-500"
                  : errors.sit_score
                  ? "bg-red-50 text-black border-red-500"
                  : "bg-white text-gray-700 border-gray-300 hover:bg-gray-100"
              }`}
              onClick={() => {
                setFeedbackFormValues((prev) => ({
                  ...prev,
                  sit_score: score,
                  recommended_status: getRecommended(score),
                }));
                setErrors((prev) => ({ ...prev, sit_score: "" }));
              }}
            >
              {score}
            </button>
          ))}
        </div>
        {errors.sit_score && (
          <p className="text-sm text-red-600 mt-2">{errors.sit_score}</p>
        )}
      </div>
      <TextArea
        required
        label="Interviewer Comments"
        name="interviewercomments"
        value={feedbackFormValues.comments}
        onChange={(e) => handleFieldChange("comments", e.target.value)}
        error={errors.comments}
      />
    </div>
  );
};

const getRecommended = (score: number) => {
  return score >= 9
    ? "Strong Hire"
    : score >= 7
    ? "Hire"
    : score >= 5
    ? "Near Fit"
    : "Rejected";
};
